/**
 * PreviewTestimonials — Testimonial cards with star ratings
 */
import { RenderIcon } from './RenderIcon';

interface TestimonialItem {
  quote: string;
  author: string;
  role: string;
}

interface PreviewTestimonialsProps {
  data: {
    title?: string;
    items?: TestimonialItem[];
  };
  settings: {
    [key: string]: any;
  };
}

export function PreviewTestimonials({ data, settings }: PreviewTestimonialsProps) {
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <section className="preview-testimonials">
      <div className="preview-container">
        <div className="preview-section-header">
          <h2>{data.title}</h2>
        </div>

        <div className="preview-testimonials__grid">
          {data.items?.map((item, i) => (
            <div key={i} className="preview-testimonial">
              <div className="preview-testimonial__stars">
                {[...Array(5)].map((_, j) => (
                  <span key={j}>
                    <RenderIcon name="star" />
                  </span>
                ))}
              </div>
              <p className="preview-testimonial__quote">"{item.quote}"</p>
              <div className="preview-testimonial__author">
                <div className="preview-testimonial__avatar">
                  {getInitials(item.author)}
                </div>
                <div>
                  <div className="preview-testimonial__name">
                    {item.author}
                  </div>
                  <div className="preview-testimonial__role">
                    {item.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
